import { REQUIRED_MESSAGE } from '@wyz/utils';
import z from 'zod';

export const wcwSearchFormSchema = z.object({
  vehicleTypeGroup: z.string(),
  identifier: z.object({ value: z.string(), label: z.string() }).nullish(),
  rawIdentifier: z.string().nullish(),
  brand: z.string().nullish(),
  model: z.string().nullish(),
  versions: z.array(z.string()).nullish(),
  seasons: z.array(z.string()).min(1, REQUIRED_MESSAGE),
  set: z.union([z.literal(1), z.literal(2), z.literal(4)]).nullish(),
});

export type IWcwSearchFormSchema = z.infer<typeof wcwSearchFormSchema>;
